import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const packageGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // packageGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.PACKAGE) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const packagePlans = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // packagePlans is 2
    if (appID !== constAppID.PACKAGE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'packageQuote' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const packageApplicant = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // packageApplicant is 3
    if (appID !== constAppID.PACKAGE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'packageQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'packageQuotePlans' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const packageRisk = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // packageRisk is 4
    if (appID !== constAppID.PACKAGE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 4) {
      if (quoteLifeCycle === 1) {
        next({ name: 'packageQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'packageQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'packageQuoteApplicant' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const packagePremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // packagePayment is 5
    if (appID !== constAppID.PACKAGE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 5) {
      if (quoteLifeCycle === 1) {
        next({ name: 'packageQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'packageQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'packageQuoteApplicant' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'packageQuoteRisk' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const packagePayment = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // packagePayment is 6
    if (appID !== constAppID.PACKAGE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 6) {
      if (quoteLifeCycle === 1) {
        next({ name: 'packageQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'packageQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'packageQuoteApplicant' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'packageQuoteRisk' })
      } else if (quoteLifeCycle === 5) {
        next({ name: 'packageQuotePremium' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
